import { bindContent } from "../content/catalog"
import { lookupItemDisplayName } from "../content/item_names"

let names: Record<string, string> = {}

/**
 * What the UI calls an item, wherever it names one: the pack, the crafting bench, trade, hover text and
 * messages. Content-owned (`presentation.displayNames` in content/game/items/presentation.json): roof-wood
 * is "Roof tile, wood". A colour with its own name wins over the item's (dagger:brown is "Dagger, wood").
 *
 * Every shipped item is named (content validation refuses one that is not); an id with no name -- a saved
 * item whose type has since left the content -- reads as its id in words.
 */
export const itemDisplayName = (itemType: string, color?: string): string => lookupItemDisplayName(names, itemType, color)

/** The same, for anything carrying an item's type and colour (an ItemTypeMeta, an inventory item's meta). */
export const itemMetaDisplayName = (meta: { type?: string; color?: string } | undefined): string =>
    itemDisplayName(meta?.type || "", meta?.color)

/**
 * A count of an item in a sentence or a price: "3 × Plank". A count, not a plural -- display names are
 * catalogue names ("Roof tile, wood"), and English plurals of those are not worth guessing.
 */
export const itemCountText = (quantity: number, itemType: string, color?: string): string =>
    `${quantity} × ${itemDisplayName(itemType, color)}`

bindContent(catalog => catalog.source?.presentation?.displayNames, next => {
    names = next ?? {}
})
